import { API_BASE_URL } from "../assets/const";
import { checkAndUpdateToken } from "./auth";
import { GET_NEW_SCHOOL_YEAR } from "./types";
import { buildDefaultHeaders } from "./helper";
import { createNotification } from "../components/Notifications/Notifications";

export const getNewSchoolYear = (params) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const urlParams = new URLSearchParams(params).toString();
    const response = await fetch(`${API_BASE_URL}/new_school_year?${urlParams}`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: GET_NEW_SCHOOL_YEAR, payload: data});
    }
  }
};
